const comments = [
  {
    name: '影迷小陈',
    text: '被窝网电影真的太香了！片源更新速度超快，画质清晰还不卡顿，现在每天晚上睡前必刷一部。不用注册直接看，体验满分。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '追剧达人Linda',
    text: '追了半年的韩剧在这里都能找到高清全集，没有广告打扰真的太幸福了。移动端体验也很棒，地铁通勤路上都在用。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '老电影爱好者',
    text: '很多经典老片在其他平台都找不到了，没想到被窝网电影大全里都有！画质修复得也不错，真正做到了"被窝里看好片"。',
    rating: 4,
    date: '2026-07-22',
  },
  {
    name: '周末宅家党',
    text: '每个周末都会来被窝网电影刷一下午，分类很全，科幻迷狂喜。希望以后能有更多4K片源，那就更完美了！',
    rating: 5,
    date: '2026-07-19',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Reviews</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            听听影迷们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {comments.map((c, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`text-sm ${i < c.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{c.text}</p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{c.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{c.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}